import React, {Component} from 'react';
// import mentor1 from './images/smudali.jpg';
// import mentor2 from './images/ajitpanda.jpg';
// import mentor3 from './images/rabipreddy.jpg';
//import mentor4 from './images/ashokdas.jpg';


function FadeInSection(props) {
    const [isVisible, setVisible] = React.useState(false);
    const domRef = React.useRef();
    React.useEffect(() => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => setVisible(entry.isIntersecting));
      });
      observer.observe(domRef.current);
    }, []);
    return (
      <div
        className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
        ref={domRef}
      >
        {props.children}
      </div>
    );
  }

class Company extends Component{
    componentDidMount() {
        window.scrollTo(0, 0)
      }
      
    render(){
        return(
            <div className="container-fluid servicepage">
                <div className="row careersheader">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    </div>
                </div>
                <div className="row">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 sectionheading">
                                <h2>About CollabDots ?</h2>
                            </div>                            
                        </div>                       
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="container">
                        <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 companytxt">
                        <p>
                        <b>CollabDots</b> has been established by some highly experienced Professionals dedicated to
                        provide total IT solutions under one roof. We are a software development firm with a mission
                        of providing innovative services and vision of serving clients in future technologies. We are a
                        customer centric IT Company. We work in different technologies like IT development, Energy
                        Monitoring and Optimal control, Embedded System, VLSI design and Fabrication, Smart
                        Agriculture etc. Our mission is “to covert the technology lagging Indian and developing
                        world workspaces to the productive future tech spaces through appropriate re-engineering,
                        training and enabling them to compete in the recent global market”. We Provide quality
                        services to our clients with assurance of maximum value for money. We listen to your ideas
                        and create custom software solutions from the ground up, designed especially for your
                        business. We create diverse, complex, web and mobile solutions for any business need.
                        CollabDots offers a service to update or replace your outdated systems with cutting-edge
                        new technologies and efficient custom software systems. The engineers of CollabDots have
                        the experience of working with required technical platforms and languages to help you
                        create a secure and scalable IoT solution that fits your business needs. From creating the
                        solution’s architecture to sensors to building cloud infrastructure we can help you with both
                        hardware and software. 
                        </p>
                     </div>
                        </div>
                    </div>                     
                </div>

                {/* <div className="row">
                    <div className="container">                                                
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 sectionheading">
                                <h2>Advisors & Mentors</h2>
                                <p>
                                    We will always be grateful to you for your support and kindness. <br />It would be impossible to count all the ways in which you have helped us in our career. 
                                </p>
                                
                            </div>
                        </div>
                        <div className="row mntors-section">
                            <div className=" col-lg-2 col-xl-2"></div>
                            <div className=" col-lg-8 col-xl-8">
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mentors">
                                    <FadeInSection>
                                        <img src={mentor1} className="img-fluid" alt="CollabDots" /> 
                                    </FadeInSection>
                                        <p>Prof. Sangram Mudali</p>
                                        <span>Director, NIST</span><br />
                                        <span>Alumnus - IIT, Kanpur</span>
                                    </div>
                                    
                                    
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mentors">
                                    <FadeInSection>
                                        <img src={mentor2} className="img-fluid" alt="CollabDots" />
                                    </FadeInSection> 
                                        <p>Dr Ajit Kumar Panda</p>
                                        <span>IEEE, Distinguished Lecturer</span><br />
                                        <span>Post Doctorate, USA</span>
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mentors">
                                    <FadeInSection>
                                        <img src={mentor3} className="img-fluid" alt="CollabDots" />
                                    </FadeInSection> 
                                        <p>Prof. Ravi P Reddy</p>
                                        <span>VP, Megha Engineering</span><br />
                                        <span>Alumnus - IIT, Kharagpur</span> 
                                    </div>
                                    
                                    
                                </div>
                            </div> 
                            <div className=" col-lg-2 col-xl-2"></div>
                        </div>
                    </div>
                </div> */}

                {/*<div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mentors">
                                    <FadeInSection>
                                        <img src={mentor4} className="img-fluid" alt="CollabDots" />
                                    </FadeInSection> 
                                        <p>Dr Ashok Kumar Das</p>
                                        <span>CEO, Sunmoksha</span><br />
                                        <span>Alumnus - IIT, Kanpur</span> 
                                    </div>*/}


            </div>            
        );
    }
}

export default Company;